import React from 'react'
import CategoryPage from './CategoryPage'

const Men = () => {
    return <CategoryPage urlCategory="men" />
}

export default Men